export default "__VITE_ASSET__CH9YpI1s__"